import http from '@/plugins/http'
const adminApi = process.env.VUE_APP_ADMIN_API;
//获取我的车型
export const getDownloadsList = (params={}) => {
    const url = adminApi  + 'report/researchReport'
    return http.fetchPost(url, params);
}
//获取我的车型
export const downReport = (params={},res_params) => {
    const url = adminApi  + 'report/researchReportDownload';
    return http.fetchPost(url, params, res_params);
}